import { Reducer } from "redux";
import { PlanListItem } from "../../service/api-response/PlanListSuccessResponse";
import { Subscription } from "../../service/api-response/SubscriptionsSuccessResponse";
import * as subscriptionActions from "./subscriptionActions";
import produce from "immer";

export interface SubscriptionState {
  subscriptions: {
    [userId: string]: Subscription[] | undefined;
  };
  isLoadingSubscriptions: {
    [userId: string]: boolean;
  };
  isLoadingPlans: {
    [organization: string]: boolean;
  };
  plans: {
    [organization: string]: PlanListItem[];
  };
}

const initialState: SubscriptionState = {
  subscriptions: {},
  isLoadingSubscriptions: {},
  plans: {},
  isLoadingPlans: {},
};

type SupportedActions =
  | subscriptionActions.GetSubscriptionListForUser
  | subscriptionActions.GetSubscriptionListForUserFail
  | subscriptionActions.GetSubscriptionListForUserSuccess
  | subscriptionActions.GetPlanListForOrganizationAction
  | subscriptionActions.GetPlanListForOrganizationFailAction
  | subscriptionActions.GetPlanListForOrganizationSuccessAction;

export const subscriptionReducer: Reducer<
  SubscriptionState,
  SupportedActions
> = (state = initialState, action) => {
  return produce(state, (draftState) => {
    switch (action.type) {
      case subscriptionActions.GET_SUBSCRIPTION_LIST_FOR_USER: {
        delete draftState.subscriptions[action.userId];
        draftState.isLoadingSubscriptions[action.userId] = true;
        break;
      }
      case subscriptionActions.GET_SUBSCRIPTION_LIST_FOR_USER_SUCCESS: {
        draftState.subscriptions[action.userId] = action.subscriptions;
        draftState.isLoadingSubscriptions[action.userId] = false;
        break;
      }
      case subscriptionActions.GET_SUBSCRIPTION_LIST_FOR_USER_FAIL: {
        draftState.isLoadingSubscriptions[action.userId] = false;
        break;
      }
      case subscriptionActions.GET_PLAN_LIST_FOR_ORGANIZATION: {
        draftState.isLoadingPlans[action.organizationKeyName] = true;
        break;
      }
      case subscriptionActions.GET_PLAN_LIST_FOR_ORGANIZATION_SUCCESS: {
        draftState.isLoadingPlans[action.organizationKeyName] = false;
        draftState.plans[action.organizationKeyName] = action.data;
        break;
      }
      case subscriptionActions.GET_PLAN_LIST_FOR_ORGANIZATION_FAIL: {
        draftState.isLoadingPlans[action.organizationKeyName] = false;
        break;
      }
      default: {
        return;
      }
    }
  });
};
